import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { FetchClassificationApi, FetchClassificationRequest, FetchClassificationResponse } from '../fetch-classification-api';
import { coreSearchApiUrlPrefix, coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

export class FetchClassificationApiImpl extends PsHttpService
    implements FetchClassificationApi {


    async fetchClassification(params: FetchClassificationRequest): Promise<FetchClassificationResponse> {
        const res = await this.get<PatSnapSuccessResponseData<FetchClassificationResponse>>({
            url: 'patent/ipc-classification/detail',
            cache: true,
            params,
        });
        return res.data;
    }

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
}
